import { TbLayoutGrid } from 'react-icons/tb';

import './Card.styles.css';
import { useTranslation } from 'react-i18next';

export default function Card(link: { id: number; name: string; path: string; count: number }) {
  const { t } = useTranslation();
  return (
    <div className="card">
      <div className="icon">
        <TbLayoutGrid />
      </div>
      <div className="title">{link.name}</div>
      <div className="count">
        {link.count} {t('pages.admin.elements')}
      </div>
    </div>
  );
}
